import * as $ from "jquery";
import {getArea} from "ol/sphere";
import {createFeatureFromCoordinates} from "../../map/utilities";

export const calculateAreas = () => {
    const areaPercentage = $('.area-percentage');
    const areaDistrict = $('.area-district');

    if (areaPercentage.length > 0) {
        let districtArea = parseFloat(areaDistrict.text());
        let inventoryArea = parseFloat($('.area-inventory').text());

        if (districtArea === 0 && window._locations.length > 0) {
            try {
                const locations = JSON.parse(window._locations);

                let districts = [];
                for(const location of locations) {
                    if(districts.includes(location.district.id)) {
                        continue;
                    }

                    districtArea += getArea(createFeatureFromCoordinates(location.district.coordinates).getGeometry()) / 10000;
                    districts.push(location.district.id)
                }

                areaDistrict.text(districtArea.toFixed(2))
            } catch (err) {
            }
        }

        if (inventoryArea === 0) {
            areaPercentage.text('Nie wprowadzono obszaru inwentaryzacji');
            return;
        }

        if (districtArea === 0) {
            areaPercentage.text('Nie wprowadzono granic obwodu');
            return;
        }

        let percentage = (inventoryArea / districtArea) * 100;
        areaPercentage.text(percentage.toFixed(2) + '%');
    }
}